module.exports = __webpack_public_path__ + "assets/img/05a.dfa45758.jpg";